import * as React from "react"
import Svg, { Path } from "react-native-svg"

// <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
//      stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
//      class="icon icon-tabler icons-tabler-outline icon-tabler-mail">
//     <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
//     <path d="M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10"/>
//     <path d="M3 7l9 6l9 -6"/>
// </svg>

function MailAltSvg(props) {
    return (
        <Svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke={'currentColor'}
            {...props}
        >
            <Path stroke={'none'} d={'M0 0h24v24H0z'} fill={'none'} />
            <Path d={'M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10'} />
            <Path d={'M3 7l9 6l9 -6'} />
        </Svg>
    )
}

export default MailAltSvg;